import { useEffect, useState } from "react";
import { Users } from "lucide-react";
import api from "@/lib/api";

// Zeigt, wer bei Mails zu diesem Projekt automatisch eine versteckte Kopie (BCC) bekommt.
export function TeamCopyNote({ projectId, className = "" }) {
  const [team, setTeam] = useState(null);
  useEffect(() => {
    if (!projectId) return;
    api.get(`/projects/${projectId}/email-team`).then((r) => setTeam(r.data.team || [])).catch(() => setTeam([]));
  }, [projectId]);
  if (!team?.length) return null;
  return (
    <div className={`rounded-lg border border-zinc-800 bg-zinc-900/60 px-3 py-2 text-[11.5px] text-zinc-400 ${className}`} data-testid="team-copy-note">
      <div className="inline-flex items-center gap-1.5 font-semibold text-zinc-300"><Users size={12} /> Kopie (BCC) automatisch an:</div>
      <div className="mt-0.5 leading-relaxed">
        {team.map((t, i) => (
          <span key={t.email} data-testid={`team-copy-${t.role}-${i}`}>
            {i > 0 && " · "}{t.name} <span className="text-zinc-500">({t.role_label})</span>
          </span>
        ))}
      </div>
    </div>
  );
}
